export function initFAQs() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=faqs',
            FAQs
        );
    }
}

export function FAQs() {
    var acc = document.querySelectorAll(".faq");
    [...acc].forEach(function (v, i, a) {
        var toggle = v.querySelector('.toggle');

        if (toggle) {
            toggle.addEventListener('click', function () {
                this.classList.toggle('active');

                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
        }

    });
}
